import {put, takeLatest, select, call} from 'redux-saga/effects';
import JSONFormData from '../../../utils/JSONFormData';
import * as actions from '../../actions';
import {AxiosResponse} from 'axios';
import {ActionType} from 'typesafe-actions';
import {Account} from '../../../services/endpoints';
import { PhonebookRecord } from '../../actions/accountPhoneBook/payloads';
import { APIErrorInterface, ReduxState } from '../../types';
import {api} from '../../services/axios';
import { PeersContactListItem } from '../../actions/accountDashboard/payloads';

export function* getAccountPhoneBookList(
    action: ActionType<typeof actions.getAccountPhoneBookList.request>,
) {
    try {
        const {session_id, csrf_token} = yield select((state: ReduxState) => state.auth);
        const body = new JSONFormData(session_id, csrf_token);
        body.setParams(action.payload);

        const response: AxiosResponse<{
            phonebook_rec_list: PhonebookRecord[];
            total: number;
        }> = yield api.post(Account.GetPhonebookList, body);

        yield put(
            actions.getAccountPhoneBookList.success({
                list: response.data.phonebook_rec_list ?? [],
                total: response.data.total,
            })
        );
    } catch (err) {
        //@ts-ignore
        const error = err?.response?.data;
        yield put(actions.getAccountPhoneBookList.failure(error));
    }
}

export function* addEditAccountPhoneBookRecord(
    action: ActionType<typeof actions.addEditAccountPhoneBookRecord.request>,
) {
    try {
        const {session_id, csrf_token} = yield select((state: ReduxState) => state.auth);
        const body = new JSONFormData(session_id, csrf_token);
        body.setParams({
            phonebook_rec_info: action.payload.record
        });

        const endpoint = action.payload.record?.i_account_phonebook ? Account.UpdatePhonebookRecord : Account.AddPhonebookRecord;
        const response: AxiosResponse<{
            i_account_phonebook: number | null;
        }> = yield api.post(endpoint, body);

        action.payload.callback?.();
        yield put(
            actions.addEditAccountPhoneBookRecord.success(response.data.i_account_phonebook)
        );
    } catch (err) {
        //@ts-ignore
        const error = err?.response?.data;
        action.payload.callback?.(error);
        yield put(actions.addEditAccountPhoneBookRecord.failure(error));
    }
}

export function* deleteAccountPhoneBookRecord(
    action: ActionType<typeof actions.deleteAccountPhoneBookRecord.request>,
) {
    try {
        const {session_id, csrf_token} = yield select((state: ReduxState) => state.auth);
        const body = new JSONFormData(session_id, csrf_token);
        body.setParams({
            i_account_phonebook: action.payload.i_account_phonebook
        });

        yield api.post(Account.DeletePhonebookRecord, body);

        action.payload.callback?.();
        yield put(
            actions.deleteAccountPhoneBookRecord.success()
        );
    } catch (err) {
        //@ts-ignore
        const error = err?.response?.data;
        action.payload.callback?.(error);
        yield put(actions.deleteAccountPhoneBookRecord.failure(error));
    }
}

export function* setAccountPhoneBookRecordFavorit(
    action: ActionType<typeof actions.setAccountPhoneBookRecordFavorit.request>,
) {
    try {
        
        const list: PhonebookRecord[] | undefined = yield select((state: ReduxState) => state.accountPhoneBook?.list);
        const total: number | undefined = yield select((state: ReduxState) => state.accountPhoneBook?.total);

        const record = list?.find(e => e.i_account_phonebook == action.payload.i_account_phonebook);
        const updatedRecord = record
            ? {...record, favorite_rating: action.payload.value}
            : undefined;

        let result: APIErrorInterface | undefined = undefined;
        if(updatedRecord)
        {
            yield call(addEditAccountPhoneBookRecord, actions.addEditAccountPhoneBookRecord.request({
                record: updatedRecord,
                callback: (err: APIErrorInterface | undefined) => {
                    result = err;
                },
            }));
        }

        action.payload.callback?.(result);
        if(result == undefined)
        {
            yield put(
                actions.getAccountPhoneBookList.success({
                    list: updatedRecord
                        ? (list ?? []).map(e => e === record ? updatedRecord : e)
                        : (list ?? []),
                    total: total ?? 0,
                })
            );

            yield put(
                actions.setAccountPhoneBookRecordFavorit.success()
            );
        }
        else
        {
            yield put(actions.setAccountPhoneBookRecordFavorit.failure(result));
        }
    } catch (err) {
        //@ts-ignore
        const error = err?.response?.data;
        action.payload.callback?.(error);
        yield put(actions.setAccountPhoneBookRecordFavorit.failure(error));
    }
}

export const accountPhoneBookSaga = [
        takeLatest(
            actions.getAccountPhoneBookList.request,
            getAccountPhoneBookList,
        ),
        takeLatest(
            actions.addEditAccountPhoneBookRecord.request,
            addEditAccountPhoneBookRecord,
        ),
        takeLatest(
            actions.deleteAccountPhoneBookRecord.request,
            deleteAccountPhoneBookRecord,
        ),
        takeLatest(
            actions.setAccountPhoneBookRecordFavorit.request,
            setAccountPhoneBookRecordFavorit,
        )
    ]
;